import { render, staticRenderFns } from "./character_form.vue?vue&type=template&id=79d8d20a"
import script from "./character_form.vue?vue&type=script&lang=ts"
export * from "./character_form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports